import { initClient, tsRestFetchApi } from "@ts-rest/core";
import { getAuth } from "firebase/auth";

import { patientsApiContract } from "@libs/api/patients";
import { getLanguage } from "@/i18n/utils";
import { envVariables } from "@/utils/envVariables";

export const tsRestClient = () => {
  return initClient(patientsApiContract, {
    baseUrl: envVariables.EXPO_PUBLIC_SERVER_URL,
    jsonQuery: true,
    api: async args => {
      // Read the token directly from Firebase (not authStore) so requests made
      // immediately after sign-in don't race the async store hydration and go
      // out unauthenticated. getIdToken() returns the cached token instantly.
      const idToken = await getAuth().currentUser?.getIdToken();
      if (idToken) {
        args.headers = {
          ...args.headers,
          Authorization: `Bearer ${idToken}`,
        };
      }

      args.headers = {
        ...args.headers,
        "Accept-Language": getLanguage(),
      };

      return tsRestFetchApi(args);
    },
  });
};
